import * as React from 'react';

import Overflow16 from './Overflow16';

export const overflow16 = () => <Overflow16 />;

export default {
    title: 'Icon/Fill/Overflow16',
    component: Overflow16,
    parameters: {
        notes: "`import Overflow16 from 'box-ui-elements/es/icon/fill/Overflow16';`",
    },
};
